module.exports = __webpack_public_path__ + "static/img/bg-fr.acd5966d.png";